import { useEffect, useState } from 'react';
import { getProductionMix } from '../services';
import { IProductionMixItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useProductionMix(
	from: string,
	to: string,
	options?: { sellerId?: number; team?: string; enabled?: boolean },
): HookState<IProductionMixItem[]> {
	const [state, setState] = useState<HookState<IProductionMixItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const sellerId = options?.sellerId;
	const team = options?.team;
	const enabled = options?.enabled ?? true;

	useEffect(() => {
		if (!from || !to || !enabled) return;

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getProductionMix(from, to, { sellerId, team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [from, to, sellerId, team, enabled]);

	return state;
}
